import {useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const {FiPlus,FiArrowUpRight} = FiIcons;
const WA = 'https://wa.me/919876543210?text=Hi%20Aurelle!%20I%20have%20a%20question.';

const faqs = [
  {q: 'How do I place an order?',a: 'Tap any button on this site — it opens a WhatsApp chat. Share the piece you love and we confirm sizes,availability and payment within minutes.'},
  {q: 'Do you help with styling?',a: 'Absolutely. Send us the occasion and we will curate a mini edit for you,complete with accessories,right inside the chat.'},
  {q: 'How long does delivery take?',a: 'Metro cities receive orders in 2–3 working days;the rest of India within 5–7 days. Express options are available on request.'},
  {q: 'Can I visit the boutique?',a: 'Yes — message us on WhatsApp to book a private styling appointment at our studio,with tea on us.'}
];

function FAQSection() {
  const [open,setOpen] = useState(0);

  return (
    <section id="faq" className="bg-[#F7F2EA] py-24 md:py-32 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-[1fr_1.4fr] gap-12">
        <div>
          <p className="eyebrow mb-5" style={{color: '#1F3D2E'}}>Good to know</p>
          <h2 className="font-display text-[clamp(36px,5vw,56px)] leading-tight text-[#1F1B17] font-light">
            Questions,<em className="italic text-[#1F3D2E]">answered</em>
          </h2>
          <p className="mt-6 max-w-sm font-sans text-sm text-[#7A6E62] leading-relaxed">Our stylists reply personally on WhatsApp,usually within a few minutes.</p>
          <a href={WA} target="_blank" rel="noreferrer" className="btn-gold mt-8 group">
            Ask us <SafeIcon icon={FiArrowUpRight} className="group-hover:translate-x-1 transition" />
          </a>
        </div>
        <div className="border-y border-[#DDD3BE]">
          {faqs.map((item,i) => (
            <div key={item.q} className="border-b border-[#DDD3BE]">
              <button onClick={() => setOpen(open === i ? -1 : i)} aria-expanded={open === i} className="flex w-full items-center justify-between gap-6 py-6 text-left">
                <span className="font-display text-xl md:text-2xl text-[#1F1B17]">{item.q}</span>
                <SafeIcon icon={FiPlus} className={`flex-none text-xl text-[#1F3D2E] transition-transform duration-300 ${open === i ? 'rotate-45' : ''}`} />
              </button>
              <motion.div initial={false} animate={{height: open === i ? 'auto' : 0,opacity: open === i ? 1 : 0}} transition={{duration: 0.3}} className="overflow-hidden">
                <p className="pb-6 pr-10 font-sans text-sm leading-relaxed text-[#7A6E62]">{item.a}</p>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
